import Color from "color";
String.prototype.color = function () {
    return Color(this);
};
const colorPrototype = Color.prototype;
colorPrototype.ladd = function (delta) {
    return this.l(this.l() + delta);
};
colorPrototype.sadd = function (delta) {
    return this.saturationl(this.saturationl() + delta);
};
